import { Contributors } from '@/app/(webapp)/_types/contributors';

export const producers: Contributors[] = [
    { id: 'espn', name: 'ESPN', src: '/images/producers/espn.png' },
    { id: 'liminal', name: 'Liminal', src: '/images/producers/liminal.png' },
    { id: 'ksw', name: 'KSW', src: '/images/producers/ksw.png' },
    { id: 'lctv', name: 'LCTV', src: '/images/producers/lctv.png' },
    { id: 'millimages', name: 'Millimages', src: '/images/producers/millimages.png' },
    { id: 'motion-pictures', name: 'Motion Pictures', src: '/images/producers/motion-pictures.png' },
    { id: 'quattro-media', name: 'Quattro Media', src: '/images/producers/quattro-media.png' },
    { id: 'son-et-lumiere', name: 'Son et Lumière', src: '/images/producers/son-et-lumiere.png' },
    { id: 'spica-productions', name: 'Spica Productions', src: '/images/producers/spica-productions.png' },
    { id: 'zoland', name: 'Zoland', src: '/images/producers/zoland.png' },
];
